import React from "react";
import { useI18n } from "@/i18n/I18nProvider";
import {
  Factory,
  Wrench,
  Truck,
  Boxes,
  Shield,
  ClipboardList,
  Gauge,
  Zap,
  Cog,
  HardHat,
  Layers,
} from "lucide-react";

const ICONS = [
  Factory,
  Wrench,
  Truck,
  Boxes,
  Shield,
  ClipboardList,
  Gauge,
  Zap,
  Cog,
  HardHat,
  Layers,
];

export default function AtlasAreas() {
  const { t, messages } = useI18n();
  const items = messages?.areas?.items || [];
  return (
    <section
      id="que-puede-gestionar"
      data-testid="atlas-areas"
      className="py-16 lg:py-24 bg-white"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-2 text-[#6B46C1] uppercase tracking-[0.18em] text-xs font-bold">
          <Layers size={14} />
          <span>{t("areas.badge")}</span>
        </div>
        <h2
          data-testid="areas-title"
          className="mt-4 font-display text-3xl sm:text-4xl lg:text-[44px] leading-tight font-extrabold text-slate-900 max-w-3xl"
        >
          {t("areas.titleA")}{" "}
          <span className="text-[#6B46C1]">{t("areas.titleB")}</span>
        </h2>
        <p className="mt-3 text-slate-600 text-base sm:text-lg max-w-2xl">
          {t("areas.subtitle")}
        </p>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-5">
          {items.map((it, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <div
                key={i}
                data-testid={`area-card-${i}`}
                className="group relative rounded-2xl border border-slate-200 bg-white p-5 sm:p-6 transition-all hover:-translate-y-0.5 hover:shadow-lg hover:border-[#6B46C1]/40"
              >
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 h-11 w-11 rounded-xl bg-[#6B46C1]/10 text-[#6B46C1] flex items-center justify-center transition-colors group-hover:bg-[#6B46C1] group-hover:text-white">
                    <Icon size={20} strokeWidth={2.2} />
                  </div>
                  <div className="min-w-0">
                    <h3 className="font-display font-bold text-slate-900 text-base sm:text-lg leading-snug">
                      {it.title}
                    </h3>
                    <p className="mt-2 text-slate-600 text-sm leading-relaxed">
                      {it.desc}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
